export const faqs = [
  {
    id: "faq-1",
    question: "Apa itu KKN-PLP Terintegrasi?",
    answer:
      "KKN-PLP Terintegrasi adalah program pengabdian masyarakat (KKN) yang dilaksanakan bersamaan dengan Praktik Lapangan Persekolahan (PLP). Mahasiswa mengabdi di masyarakat sekaligus mengajar di sekolah-sekolah mitra, sehingga dampak pendidikan dan sosial berjalan beriringan.",
  },
  {
    id: "faq-2",
    question: "Kapan dan di mana kegiatan ini berlangsung?",
    answer:
      "Kegiatan berlangsung pada Juli hingga September 2026 (45 hari efektif) di Kelurahan Kedungwuni Barat, Kecamatan Kedungwuni, Kabupaten Pekalongan, Jawa Tengah.",
  },
  {
    id: "faq-3",
    question: "Apa program unggulan Kelompok 55?",
    answer:
      "Program unggulan kami adalah Gerakan Eco Masjid melalui Sedekah Sampah — menjadikan masjid sebagai pusat gerakan peduli lingkungan, di mana jamaah dapat bersedekah dengan sampah terpilah yang hasilnya kembali untuk kegiatan sosial.",
  },
  {
    id: "faq-4",
    question: "Bagaimana warga bisa ikut berpartisipasi?",
    answer:
      "Warga dapat bergabung dalam kerja bakti, menyetorkan sampah terpilah ke bank sampah, mengikuti kelas literasi, atau mengisi formulir partisipasi melalui Google Form pada menu Link Penting.",
  },
  {
    id: "faq-5",
    question: "Bagaimana cara berkolaborasi atau menjadi mitra?",
    answer:
      "Silakan hubungi kami melalui WhatsApp atau email yang tercantum di bagian Kontak. Kami terbuka untuk kolaborasi dengan sekolah, masjid, UMKM, komunitas, maupun instansi.",
  },
  {
    id: "faq-6",
    question: "Di mana saya bisa melihat laporan kegiatan?",
    answer:
      "Laporan harian, dokumentasi, dan dashboard progres program kerja dapat diakses melalui Quick Access Hub pada bagian Link Penting di website ini.",
  },
];
